import React from 'react';
import { FormData, FormErrors } from '../../types';
import { FormField, Input } from '../FormField';
interface SectionProps {
  data: FormData;
  errors: FormErrors;
  onChange: (field: keyof FormData, value: any) => void;
}
export function Section1({
  data,
  errors,
  onChange
}: SectionProps) {
  return <div className="space-y-6" data-id="element-25">
      <div className="mb-8 border-b border-plateado/30 pb-4" data-id="element-26">
        <h2 className="font-serif text-2xl text-azul-profundo" data-id="element-27">
          <span className="text-dorado mr-2" data-id="element-28">Sección 01 ·</span>
          Datos Personales
        </h2>
        <p className="text-gray-600 mt-2" data-id="element-29">
          Queremos conocerte un poco mejor para personalizar tu experiencia.
        </p>
      </div>

      <FormField label="¿Cuál es tu nombre completo?" name="nombre" error={errors.nombre} required data-id="element-30">
        <Input id="nombre" type="text" value={data.nombre} onChange={e => onChange('nombre', e.target.value)} error={!!errors.nombre} placeholder="Ej. María Pérez" data-id="element-31" />
      </FormField>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-32">
        <FormField label="Edad" name="edad" error={errors.edad} required data-id="element-33">
          <Input id="edad" type="number" value={data.edad} onChange={e => onChange('edad', e.target.value)} error={!!errors.edad} placeholder="Ej. 35" min="18" max="100" data-id="element-34" />
        </FormField>

        <FormField label="Ciudad y País" name="ciudad" error={errors.ciudad} required data-id="element-35">
          <Input id="ciudad" type="text" value={data.ciudad} onChange={e => onChange('ciudad', e.target.value)} error={!!errors.ciudad} placeholder="Ej. Madrid, España" data-id="element-36" />
        </FormField>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-37">
        <FormField label="Correo Electrónico" name="email" error={errors.email} required data-id="element-38">
          <Input id="email" type="email" value={data.email} onChange={e => onChange('email', e.target.value)} error={!!errors.email} placeholder="tu@email.com" data-id="element-39" />
        </FormField>

        <FormField label="Teléfono / WhatsApp" name="telefono" error={errors.telefono} required data-id="element-40">
          <Input id="telefono" type="tel" value={data.telefono} onChange={e => onChange('telefono', e.target.value)} error={!!errors.telefono} placeholder="+34 600 000 000" data-id="element-41" />
        </FormField>
      </div>
    </div>;
}